// ColorPicker.js
import { Modal } from "@mui/material";
import React, { useState } from "react";
import { SketchPicker } from "react-color";
import useEyeDropper from "use-eye-dropper";
import { ASSETS } from "../../utils/config";
import Button from "../Button";
import "./styles.css";

const CustomColorPicker = ({
  visible,
  onClose,
  onConfirm,
  color,
  onColorChange,
  customStyle,
}) => {
  const { open, isSupported } = useEyeDropper();
  const [isPickingColor, setIsPickingColor] = useState(false);

  const handleEyeDropperClick = async () => {
    setIsPickingColor(true);
    try {
      const color = await open();
      onColorChange(color.sRGBHex);
    } catch (error) {
      console.error("Eye Dropper error:", error);
    } finally {
      setIsPickingColor(false);
    }
  };

  return (
    <Modal hideBackdrop open={visible} onClose={onClose}>
      <div
        style={{
          position: "absolute",
          zIndex: 99,
          bottom: 10,
          left: "18vw",
          backgroundColor: "white",
          padding: 15,
          borderRadius: 10,
          boxShadow: "0px 4px 8px #3b3b3baa",
          width: 300,
          ...customStyle,
        }}
      >
        <SketchPicker
          disableAlpha
          color={color}
          onChange={(color) => onColorChange(color.hex)}
          presetColors={[]}
        />

        {isSupported && (
          <Button
            variant={"outlined"}
            style={{ height: 36, marginTop: 10 }}
            onClick={handleEyeDropperClick}
            disabled={isPickingColor}
          >
            <img src={ASSETS.ColorPicker} style={{width:20,height:20,marginRight:10}}/>{"Pick a Color"}
          </Button>
        )}

        <div style={{ marginTop: 12, display: "flex" }}>
          <Button
            onClick={onClose}
            secondary
            style={{ width: 200, marginRight: 10 }}
          >
            Cancel
          </Button>
          <Button onClick={() => onConfirm(color)}>Done</Button>
        </div>
      </div>
    </Modal>
  );
};

export default CustomColorPicker;
